import { combineReducers } from '@reduxjs/toolkit';
import championshipSlice from './championship';
import { bracketsSlice, groupsSlice, stagesSlice } from './stages';

const championshipsReducer = combineReducers({
  championship: championshipSlice,
  stages: stagesSlice.reducer,
  groups: groupsSlice.reducer,
  brackets: bracketsSlice.reducer,
});

export default championshipsReducer;
